<template>
  <el-container id="app">
    <el-header :class="[!changebk?'headerindex':'headerbar']" >
      <div style="width: 1108px; margin: 0 auto; display: flex; justify-content: space-between; align-items: center; min-width: 720px">
        <el-image :src="!changebk?'../../../static/images/bimstacks-logo.png':'../../../static/images/BIMStackslogo.png'" style="width: 12rem"></el-image>
        <el-menu
          :default-active="$route.path"
          router
          mode="horizontal"
          @select="handleSelect"
          :text-color="!changebk?'white':'black'"
          active-text-color="white">
          <el-menu-item index="/" @click="changebk=0,addScroll()">首页</el-menu-item>
          <el-submenu index="2">
            <template slot="title">公司产品</template>
            <el-menu-item index="/BIMPlatformCommon"   @click="changebk=1,removeScroll()"><el-image src="../../../static/images/BIMPlatformCommon/BIMProduct.png" style="width: 135px;height: 24px;"></el-image></el-menu-item>
            <el-menu-item index="/BIMIssueTrack" @click="changebk=1,removeScroll()"><el-image src="../../../static/images/BIMPlatformCommon/BIMQuestion.png" style="width: 135px;height: 24px;"></el-image></el-menu-item>
            <el-menu-item index="/BIMFamilyLibWeb" @click="changebk=1,removeScroll()"><el-image src="../../../static/images/BIMPlatformCommon/BIMMemmber.png" style="width: 117px;height: 24px;"></el-image></el-menu-item>
          </el-submenu>
          <el-menu-item index="/CustomerCase" @click="changebk=1,removeScroll()">客户案例</el-menu-item>
          <el-menu-item index="/AboutUs" @click="changebk=1,removeScroll()">关于我们</el-menu-item>
        </el-menu>
      </div>
    </el-header>
    <el-main>
      <router-view/>
    </el-main>
    <el-footer>
      <el-row>
        <el-col :span="24">
          <div style="display: flex; justify-content: center; align-content: center; flex-wrap: wrap; padding: 2rem 0; background-color: #666666">
            <div style="display: flex; justify-content: center; align-items: flex-start; flex-wrap: wrap; flex-flow: column; width: 1108px">
              <div style="display: flex; justify-content: flex-start; align-items: center; margin: 2rem 0 0rem">
                <el-image style="width: 8rem;"
                          src="../../../static/images/bimstacks-logo-svg.svg"
                          fit="cover"></el-image>
              </div>
              <p style="opacity: 0.5; color: #FFF; margin: 0.5rem 0; font-size: 0.875rem">
                Copyright  2019-2021 BIM Stacks Data Tech. CO., LTD. All rights reserved.&nbsp; <a style="color: #FFF; margin: 0.5rem 0; font-size: 0.875rem; text-decoration: none;" href=" https://beian.miit.gov.cn/#/Integrated/index" target="_blank"> {{name}} </a>
              </p>
              <p style="opacity: 0.5; margin: 0 0 2rem; color: #FFF; font-size: 0.875rem">
                联系我们：support@bimstacks.com
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'App',
  data: function () {
    return {
      activeIndex: '1',
      changebk:'',
      name: ''
    }
  },
  components: {

  },
  created() {

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
    try{
      this.name = WEB_CONFIG.RECORD_NAME
    }catch(e){
      this.name = '沪ICP备19022178号-1'
    }
  },
  methods: {
     handleSelect(key, keyPath) {
    },
    handleScroll(){
      var top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset);
      if(top>=800){
        this.changebk = 1;
      }else{
        this.changebk = 0;
      }
    },
    removeScroll(){
      window.removeEventListener("scroll", this.handleScroll, true);
    },
    addScroll(){
      window.addEventListener('scroll', this.handleScroll, true)
    }
  },
  destroyed() {

	}
}
</script>

<style>
  body {
    padding: 0;
    margin: 0;
  }
  .headerindex{
    background-color:rgba(25,43,64, 0.1);
  }
  .el-menu{
    color: white;
  }
  .headerbar{
  background-color:white!important;
  opacity: 0.9;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100vw;
    height: 100vh;
  }

  ::-webkit-scrollbar {
    width: 0;
    height: 5px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
  }

  body .el-menu--horizontal .el-menu .el-menu-item {
    padding: 0 1rem;
    height: 3rem;
    line-height: 2.5rem;
    border-bottom: 1px solid #dddddd;
  }

  body .el-menu--horizontal .el-menu .el-menu-item:last-child {
    border: none;
  }

  body .el-menu--popup {
    margin: 0 !important;
    border-radius: 0;
    padding: 0.625rem;
    min-width: 10rem;
  }
</style>

<style scoped>
  #app /deep/ .el-header {
    position: fixed;
    width: 100%;
    height: 5rem !important;
    background-color: rgba(0,0,0, .8);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 2;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
  }

  #app /deep/ .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
    display: none;
  }

  #app /deep/ .el-main {
    padding: 0;
    overflow: inherit;
  }

  #app /deep/ .el-menu {
    background: none;
  }

  #app /deep/ .el-menu.el-menu--horizontal {
    border: none;
  }

  #app /deep/ .el-menu--horizontal>.el-menu-item,
  #app /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title {
    border: none;
    height: 5rem;
    line-height: 5rem;
    width: 7rem;
    font-size: 1rem;
    font-weight: 700;
  }

  #app /deep/ .el-menu--horizontal>.el-menu-item.is-active {
    border: none;
    background-color: #f1781a;
  }

  #app /deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
  #app /deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
  #app /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title:hover,
  #app /deep/ .el-menu--horizontal>.el-submenu.is-active {
    background-color: #f1781a;
  }

  #app /deep/ .el-footer {
    padding: 0;
    height: auto !important;
    min-width: 1108px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue